import styled from "styled-components";
import { size } from "styled-theme";
import { mobileBreakPoint } from "./constants";
import LogoImageYesLoans from "@theme/assets/yes-loans-logo-old.jpg";
import React from "react";

const YesLoansLogoWrapper = styled.div`
  padding-top: 5px;

  .logo-image {
    max-height: 30px;
  }

  @media only screen and (max-width: ${size(mobileBreakPoint)}) {
    .logo-image {
      max-height: 30px;
    }
  }
`;

export const YesLoansLogo = () => (
  <YesLoansLogoWrapper>
    <img className="logo-image" src={LogoImageYesLoans} alt="logo" />
  </YesLoansLogoWrapper>
);
